import i18n from '@/plugins/i18n';

const dotnetInstanceGraphs = () => ({
  memory: {
    lineCharts: [
      {
        id: 'line-total-heap-size',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalHeapSize'),
        header: {
          title: i18n.global.t('instance.totalHeapSize'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_bytes_in_all_heaps',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        id: 'line-no-of-gen-zero-collections',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfGenZeroCollections'),
        header: {
          title: i18n.global.t('instance.noOfGenZeroCollections'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_gen0_collect_count ',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-gen-one-collections',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfGenOneCollections'),
        header: {
          title: i18n.global.t('instance.noOfGenOneCollections'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_gen1_collect_count',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-gen-two-collections',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfGenTwoCollections'),
        header: {
          title: i18n.global.t('instance.noOfGenTwoCollections'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_gen2_collect_count',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-committed-memory',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalCommittedMemory'),
        header: {
          title: i18n.global.t('instance.totalCommittedMemory'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_committed_bytes',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        id: 'line-total-reserved-memory',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalReservedMemory'),
        header: {
          title: i18n.global.t('instance.totalReservedMemory'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_reserved_bytes',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        id: 'line-heap-size',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.heapSizeByGeneration'),
        header: {
          title: i18n.global.t('instance.heapSizeByGeneration'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022', '#2F91EC', '#2AC72A'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName:
          'instance_clr_gen0_heap_size,instance_clr_gen1_heap_size,instance_clr_gen2_heap_size',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'memory',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
    ],
  },
  lockAndThreads: {
    lineCharts: [
      {
        id: 'line-no-of-logical-threads',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfLogicalThreads'),
        header: {
          title: i18n.global.t('instance.noOfLogicalThreads'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_current_logical_thread',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'lockAndThreads',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-physical-threads',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfPhysicalThreads'),
        header: {
          title: i18n.global.t('instance.noOfPhysicalThreads'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_current_physical_threads',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'lockAndThreads',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-contention-rate-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.contentionRatePerSec'),
        header: {
          title: i18n.global.t('instance.contentionRatePerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_contention_rate',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'lockAndThreads',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
      {
        id: 'line-current-queue-length',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.currentQueueLength'),
        header: {
          title: i18n.global.t('instance.currentQueueLength'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_current_queue_length',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'lockAndThreads',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-no-of-contentions',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalNoOfContentions'),
        header: {
          title: i18n.global.t('instance.totalNoOfContentions'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_contentions',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'lockAndThreads',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
    ],
  },
  loading: {
    lineCharts: [
      {
        id: 'line-percentage-time-loading',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.percentageTimeLoading'),
        header: {
          title: i18n.global.t('instance.percentageTimeLoading'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_percent_time_loading',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '%',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.percentage'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.percentage'),
        },
      },
      {
        id: 'line-bytes-in-loader-heap',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.bytesInLoaderHeap'),
        header: {
          title: i18n.global.t('instance.bytesInLoaderHeap'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_bytes_in_loader_heap',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        id: 'line-total-classes-loaded',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalClassesLoaded'),
        header: {
          title: i18n.global.t('instance.totalClassesLoaded'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_classes_loaded',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-assemblies',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalAssemblies'),
        header: {
          title: i18n.global.t('instance.totalAssemblies'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_assemblies',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-appdomains-unloaded',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalAppdomainsUnloaded'),
        header: {
          title: i18n.global.t('instance.totalAppdomainsUnloaded'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_app_domains_unloaded',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-no-of-load-failures',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalNoOfLoadFailures'),
        header: {
          title: i18n.global.t('instance.totalNoOfLoadFailures'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_load_failures',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-total-app-domains',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalAppdomains'),
        header: {
          title: i18n.global.t('instance.totalAppdomains'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_app_domains',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'loading',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
    ],
  },
  exceptions: {
    lineCharts: [
      {
        id: 'line-no-of-exceptions-thrown',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfExceptionsThrown'),
        header: {
          title: i18n.global.t('instance.noOfExceptionsThrown'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_ex_thrown',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'exceptions',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-exceptions-thrown-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfExceptionsThrownPerSec'),
        header: {
          title: i18n.global.t('instance.noOfExceptionsThrownPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_ex_thrown_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'exceptions',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
      {
        id: 'line-no-of-filters-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfFiltersPerSec'),
        header: {
          title: i18n.global.t('instance.noOfFiltersPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_filters_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'exceptions',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
      {
        id: 'line-no-of-finallys-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfFinallysPerSec'),
        header: {
          title: i18n.global.t('instance.noOfFinallysPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_finallys_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'exceptions',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
      {
        id: 'line-throw-to-catch-depth-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.throwToCatchDepthPerSec'),
        header: {
          title: i18n.global.t('instance.throwToCatchDepthPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_throw_to_catch_depth_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'exceptions',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
    ],
  },
  interops: {
    lineCharts: [
      {
        id: 'line-no-of-CCWs',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfCCWs'),
        header: {
          title: i18n.global.t('instance.noOfCCWs'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_ccws',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'interops',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-marshalling',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfMarshalling'),
        header: {
          title: i18n.global.t('instance.noOfMarshalling'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_marshalling',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'interops',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-stubs',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfStubs'),
        header: {
          title: i18n.global.t('instance.noOfStubs'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_stubs',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'interops',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-TLB-exports-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfTLBExportsPerSec'),
        header: {
          title: i18n.global.t('instance.noOfTLBExportsPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_tlb_exports_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'interops',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
      {
        id: 'line-no-of-TLB-imports-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfTLBImportsPerSec'),
        header: {
          title: i18n.global.t('instance.noOfTLBImportsPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_tlb_imports_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'interops',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
    ],
  },
  jit: {
    lineCharts: [
      {
        id: 'line-no-of-IL-bytes-jited',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfILBytesJited'),
        header: {
          title: i18n.global.t('instance.noOfILBytesJited'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_cil_bytes_jitted',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'jit',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-no-of-methods-jited',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfMethodsJited'),
        header: {
          title: i18n.global.t('instance.noOfMethodsJited'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_methods_jitted',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'jit',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-percentage-of-time-in-jit',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.percentageOfTimeInJit'),
        header: {
          title: i18n.global.t('instance.percentageOfTimeInJit'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_time_in_jit',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'jit',
        unit: '%',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.percentage'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.percentage'),
        },
      },
      {
        id: 'line-il-bytes-jited-per-sec',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.ilBytesJitedPerSec'),
        header: {
          title: i18n.global.t('instance.ilBytesJitedPerSec'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_il_bytes_jitted_per_sec',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'jit',
        unit: '%',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.countPerSec'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.countPerSec'),
        },
      },
    ],
  },
  networking: {
    lineCharts: [
      {
        id: 'line-network-io',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.networkIO'),
        header: {
          title: i18n.global.t('instance.networkIO'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022', '#2F91EC'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_bytes_received, instance_clr_bytes_sent',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'networking',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.sizeInMb'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.sizeInMb'),
        },
        aggregation: '/',
        aggregationNum: '1048576',
      },
      {
        id: 'line-connections-established',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.connectionsEstablished'),
        header: {
          title: i18n.global.t('instance.connectionsEstablished'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_connections_established',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'networking',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-datagrams-received',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.datagramsReceived'),
        header: {
          title: i18n.global.t('instance.datagramsReceived'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_datagrams_received',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'networking',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-datagrams-sent',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.datagramsSent'),
        header: {
          title: i18n.global.t('instance.datagramsSent'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_datagrams_sent',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'networking',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
    ],
  },
  security: {
    lineCharts: [
      {
        id: 'line-no-of-link-time-checks',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.noOfLinkTimeChecks'),
        header: {
          title: i18n.global.t('instance.noOfLinkTimeChecks'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_link_time_checks ',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'security',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
      {
        id: 'line-percentage-time-in-RT-checks',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.percentageTimeInRTChecks'),
        header: {
          title: i18n.global.t('instance.percentageTimeInRTChecks'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_time_in_rt_checks',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'security',
        unit: '%',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.percentage'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.percentage'),
        },
      },
      {
        id: 'line-percentage-time-sig-authenticating',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.percentageTimeSigAuthenticating'),
        header: {
          title: i18n.global.t('instance.percentageTimeSigAuthenticating'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_time_sig_authenticating',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'security',
        unit: '%',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('instance.percentage'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('instance.percentage'),
        },
      },
      {
        id: 'line-total-runtime-checks',
        width: '48%',
        language: 'DOTNET',
        title: i18n.global.t('instance.totalRuntimeChecks'),
        header: {
          title: i18n.global.t('instance.totalRuntimeChecks'),
          titleIcon: '',
          content: [],
          HideCenterMiscContent: true,
        },
        chartColor: ['#FF8022'],
        height: '12.5em',
        entityType: 'ServiceInstance',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'instance_clr_total_runtime_checks',
        queryMetricType: 'readMetricsValues',
        childQueries: [],
        chartType: 'ApexChartLine',
        dependency: 'security',
        unit: '',
        axisLabels: {
          x: i18n.global.t('time'),
          y: i18n.global.t('count'),
        },
        labels: {
          xAxis: i18n.global.t('time'),
          yAxis: i18n.global.t('count'),
        },
      },
    ],
  },
});

export default dotnetInstanceGraphs;
